import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Ctas from '../../Core/Ctas';

export const Menu = styled.div``;

export const Links = styled.ul`
  margin: 40px 0;

  li {
    display: flex;
    font-size: 1rem;
    padding: 1.125rem 1.25rem;
    border-bottom: 1px solid ${themeGet('colors.cta-border-grey')};
  }

  li:not(:first-child) {
    margin-top: 0;
  }

  a {
    font-size: 1rem;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: ${themeGet('colors.main-text')};

    &:hover,
    &:focus {
      opacity: 0.8;
      color: ${themeGet('colors.main-text')};
      text-decoration: underline;
    }
  }

  &.submenu {
    li {
      display: flex;
    }
  }
`;

export const MenuFooter = styled.div`
  display: flex !important;
  position: absolute;
  bottom: 0;
  justify-content: center;
  box-shadow: -0.25rem 0 1.25rem 0 rgba(0, 0, 0, 0.1);
  padding: 1rem 2.75rem;
  width: 100%;
  z-index: 1105;
  background: ${themeGet('colors.white')};
`;

export const StyledCtas = styled(Ctas)`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  margin: 0;
`;
